// frontend/src/pages/PrivacyPolicy.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const [content, setContent] = useState('');
  const [effectiveDate, setEffectiveDate] = useState('23-08-2025');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrivacyContent = async () => {
      try {
        setLoading(true);
        // Add timestamp to prevent caching
        const timestamp = new Date().getTime();
        const response = await axios.get(`/api/admin/terms-privacy/privacy?t=${timestamp}`, {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        // console.log('Privacy API Response:', response.data);
        if (response.data && response.data.content) {
          setContent(response.data.content);
          setEffectiveDate(response.data.effectiveDate || '23-08-2025');
          // console.log('Privacy content loaded successfully, length:', response.data.content.length);
          // console.log('Last updated:', response.data.lastUpdated);
        } else {
          // console.warn('No content found in Privacy API response');
        }
      } catch (error) {
        // console.error('Error fetching Privacy Policy:', error);
        // console.error('Error details:', error.response?.data || error.message);
        // If API fails, content will remain empty and show nothing
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyContent();
  }, []);

  if (loading) {
    return (
      <div className="privacy-container">
        <div className="privacy-content" style={{ textAlign: 'center', padding: '40px' }}>
          <p>Loading Privacy Policy...</p>
        </div>
      </div>
    );
  }

  if (!content) {
    return (
      <div className="privacy-container">
        <div className="privacy-content" style={{ textAlign: 'center', padding: '40px' }}>
          <p>Privacy Policy content is not available at the moment.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="privacy-container">
      <div className="privacy-content" dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default PrivacyPolicy;
